import { getCampaigns as getDefaultCampaings } from '@fff-web/fff-utilities';

const BOX = {
  FETCH_CAMPAIGNS_REQUEST: 'edit/fetch_campaigns_request',
  FETCH_CAMPAIGNS_SUCCESS: 'edit/fetch_campaigns_success',
  FETCH_CAMPAIGNS_FAILURE: 'edit/fetch_campaigns_failure',
};

const initialState = {
  edit: null,
  season: null,
  isLoading: false,
};

export const fetchCampaignsRequest = () => ({
  type: BOX.FETCH_CAMPAIGNS_REQUEST,
});

export const fetchCampaignsSuccess = (campaigns) => ({
  type: BOX.FETCH_CAMPAIGNS_SUCCESS,
  campaigns,
});

export const fetchCampaignsFailure = (error) => ({
  type: BOX.FETCH_CAMPAIGNS_FAILURE,
  error,
});

export const getCampaigns = () => async (dispatch) => {
  dispatch(fetchCampaignsRequest());
  try {
    const campaigns = await getDefaultCampaings();
    dispatch(fetchCampaignsSuccess(campaigns));
  } catch (error) {
    dispatch(fetchCampaignsFailure(error));
  }
};

const campaignsReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOX.FETCH_CAMPAIGNS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case BOX.FETCH_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        ...action.campaigns,
      };

    case BOX.FETCH_CAMPAIGNS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default campaignsReducer;
